import { ErroredModel } from './ErroredModel';
import { PaginationMeta } from './pagination';

export type Permission = {
  action: string;
  resources: string;
  conditions?: object;
};

export enum UserRoleModules {
  ACCOUNTS = 'accounts',
  EVENTS = 'events',
  TASKS = 'tasks',
  CONTACTS = 'contacts',
  EMPLOYEES = 'employees',
  PREFERENCES = 'preferences',
  TASK_TEMPLATES = 'task_templates',
  ACCOUNT_TEMPLATES = 'account_templates',
  CONTACT_TEMPLATES = 'contact_templates',
  EMPLOYEE_TEMPLATES = 'employee_templates',
  EVENT_TEMPLATES = 'event_templates',
  EMAIL_TEMPLATES = 'email_templates',
  USER_ROLES = 'user_roles',
  ORGANIZATIONS = 'organizations',
  INTEGRATIONS = 'integrations',
  REPORTS = 'reports',
  FORM_SUBMISSIONS = 'form_submissions',
  FORM_TEMPLATES = 'form_templates',
}

export type UserRole = ErroredModel & {
  uuid: string;
  name: string;
  description: string;
  permissions: Permission[];
  organization_uuid: string;
  billing_tier_uuid: string;
};

export type UserRoleResponse = {
  data: UserRole[];
  meta: PaginationMeta;
};
